import { RouteRecordRaw } from 'vue-router';
import { AdminHomePage } from '@/pages/admin';

export const routeName = 'Admin';

export const route: RouteRecordRaw = {
  path: '',
  name: routeName,
  component: AdminHomePage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Administração',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};
